<template>
  <!-- <v-card :color="cardStatus === 3 ? 'red' : 'default'" :dark="cardStatus === 3 ? true : false" :loading="loading"> -->
    <v-card :color="cardColor" :loading="loading">
    <v-card-title>
      PVS Status

      <div class="flex-grow-1"></div>

      <v-btn icon @click="getItemPVSStatus(propItem)">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text v-if="!loading && pvsStatus">
      <span v-if="cardStatus === 1">
        <v-row>
          <v-col class="text-right">Status:</v-col>
          <v-col class="text-left">Device have correct access token!</v-col>
        </v-row>

        <v-row>
          <v-col class="text-right">Should have:</v-col>
          <v-col class="text-left">{{ pvsStatus.item.iothub }}</v-col>
        </v-row>

        <v-row>
          <v-col class="text-right">Log:</v-col>
          <v-col class="text-left">{{ pvsStatus.tableDeviceLog[0].message }}</v-col>
        </v-row>

        <v-row>
          <v-col class="text-right">Timestamp:</v-col>
          <v-col class="text-left">{{ pvsStatus.tableDeviceLog[0].timestamp }}</v-col>
        </v-row>
      </span>

      <span v-if="cardStatus === 2">
        <v-row>
          <v-col class="text-right">Status:</v-col>
          <v-col class="text-left">Logistics have no iothub specified for device</v-col>
        </v-row>

        <v-row>
          <v-col class="text-right">Should have:</v-col>
          <v-col class="text-left">{{ pvsStatus.item.iothub }}</v-col>
        </v-row>

        <v-row>
          <v-col class="text-right">Log:</v-col>
          <v-col class="text-left">{{ pvsStatus.tableDeviceLog[0].message }}</v-col>
        </v-row>

        <v-row>
          <v-col class="text-right">Timestamp:</v-col>
          <v-col class="text-left">{{ pvsStatus.tableDeviceLog[0].timestamp }}</v-col>
        </v-row>
      </span>

      <span v-if="cardStatus === 3">
        <v-row>
          <v-col class="text-right">Status:</v-col>
          <v-col class="text-left">Device <b>DOES NOT</b> have correct access token!</v-col>
        </v-row>

        <v-row>
          <v-col class="text-right">Should have:</v-col>
          <v-col class="text-left">{{ pvsStatus.item.iothub }}</v-col>
        </v-row>

        <v-row>
          <v-col class="text-right">Log:</v-col>
          <v-col class="text-left">{{ pvsStatus.tableDeviceLog[0].message }}</v-col>
        </v-row>

        <v-row>
          <v-col class="text-right">Timestamp:</v-col>
          <v-col class="text-left">{{ pvsStatus.tableDeviceLog[0].timestamp }}</v-col>
        </v-row>
      </span>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ItemPVSStatus',

  props: ['propItem'],

  data: () => ({
    loading: false,
    pvsStatus: null,
    cardStatus: 1,
    cardColor: 'default'
  }),

  mounted () {
    console.log('ItemPVSStatus.vue - mounted() triggered')
    this.getItemPVSStatus(this.propItem)

    this.$root.$on('itemUpdated', () => {
      console.log('itemUpdated event received')
      this.getItemPVSStatus(this.propItem)
    })
  },

  methods: {
    getItemPVSStatus (item) {
      this.loading = true
      axios.get(process.env.VUE_APP_API_URL + '/item/' + item.id + '/pvsStatus')
        .then(result => {
          this.pvsStatus = result.data
          this.loading = false
          this.setCardStatus(result.data)
        })
        .catch(err => {
          console.error('Error trying to get thing PVS Status:' + err)
          this.loading = false
        })
    },

    setCardStatus (pvsStatus) {
      console.log('pvsStatus:', pvsStatus)
      if (pvsStatus.item.iothub) {
        if (pvsStatus.tableDeviceLog[0].message.includes(pvsStatus.item.iothub)) {
          this.cardStatus = 1
          this.cardColor = 'default'
        }

        if (!pvsStatus.tableDeviceLog[0].message.includes(pvsStatus.item.iothub)) {
          this.cardStatus = 3
          this.cardColor = 'red'
        }
      } else {
        this.cardStatus = 2
        this.cardColor = 'warning'
      }
    }
  }
}
</script>
